module.exports = __webpack_public_path__ + "img/LQS Analyser_old.2c46bd03.svg";